<template>
    <div class="base-tips-block">
        <div class="header">
            <div class="qrw-heading-xs bold qrw-text-content-base-primary">
                {{ title }}
            </div>
            <div class="qrw-paragraph-md qrw-text-content-base-secondary">
                {{ subtitle }}
            </div>
        </div>

        <slot />
    </div>
</template>

<style scoped>
.base-tips-block {
    display: flex;
    padding: 24px;
    border: 1px solid var(--qrw-border-base-tertiary);
    flex-direction: column;
    row-gap: 24px;
    box-shadow: var(--qrw-shadow-card-default);
    width: 100%;
    background-color: var(--qrw-background-base-primary);
    border-radius: 16px;
    box-sizing: border-box;
}

.header {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
}
</style>

<script>
export default {
    props: {
        title: String,
        subtitle: String
    }
}
</script>
